<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
      :selection="selection"
      @selection-change="handleSelectionChange"
    >
       <template slot="shopNameSlot" slot-scope="{ row }">
            <el-image v-if="row.shopIcon" style="width: 18px; height: 18px" :src="row.shopIcon"></el-image>
            <span style="margin-left: 2px;flex: 1">{{row.shopName}}</span>
      </template>
      <template slot="urlSlot" slot-scope="{row}">
        <el-link v-if="row.url" :href="row.url" target="_blank">查看</el-link>
      </template>
      <template slot="statusSlot" slot-scope="{row}">
        <span>{{ getStatusText(row.status) }}</span>
        <el-link v-if="row.status == 3" @click="imageCheckDetail(row)"> 详情</el-link>
      </template>
      <template slot="scmPublishVideoLogListSlot" slot-scope="{row}">
        <div style="display:flex;flex-wrap:wrap;margin-top: 10px;max-width: 200px;min-width: 180px;">
          <span v-for="(item,index) in row.scmPublishVideoLogList"  :key="index">
            <VideoUpload :videoStyle="videoStyle" :isListVideo='true' :video="item"/>

            <el-tooltip class="item" effect="dark" :content="item.videoMessage" placement="left-start">
              <div class="video-message">{{item.videoMessage}}</div>
            </el-tooltip>      
          </span>
        </div>
      </template>
      <template slot="errorMessageSlot" slot-scope="{row}">
        <el-tooltip popper-width="400px" class="item" effect="dark" :content="row.errorMessage" placement="top">
          <span class="line-ellipsis">{{row.errorMessage}}</span>
        </el-tooltip>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button v-if="[-2, 3].includes(row.status) && ifUseTaskScheduling" type="link" @click="stopPublish(row)"> 终止铺货 </el-button>
        <el-button v-if="(!$fromGyl || ($fromGyl && row.publishEntrance) && ![ -1, 3 ].includes(row.status))" type="link" @click="rePublish(row)" :disabled="row.status == -1 || row.status == 3">重新铺货</el-button>
      </template>
    </TableList>
    <CheckImagesDialog ref="checkImagesDialogRef" />
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import CheckImagesDialog from "./CheckImagesDialog.vue"
import tableMixins from '@mixins/table-mixins';
import no_pic from "@/assets/images/no_pic.png";
import { mapGetters, mapActions, mapMutations } from 'vuex'
import VideoUpload from '@/components/Uploads/videoUploadWithTagType.vue'
import { prodDetailByBaseItemIds, prodGetWarning , prodDisplayGoodsList} from "@/servers/prod/center";
import { getCheckImagesDetail } from '@servers/prod/log/index'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    selection: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(208)],
  components: {
    TableList,
    VideoUpload,
    CheckImagesDialog
  },
  data() {
    return {
      cols: [
        { prop: "shopName", attrs: { label: "店铺", width: "150px" }, slot: true },
        { prop: "url", attrs: { label: "商品链接" }, slot: true},
        { prop: "scmPublishVideoLogList", attrs: { label: "关联视频" ,minWidth:'130px',}, slot: true},
        { prop: "status", attrs: { label: "铺货状态" }, slot: true},
        { prop: "skuQuantity", attrs: { label: "SKU数量" } },
        { prop: "errorMessage", attrs: { label: "状态详情" ,}, slot: true},
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
      no_pic,
      videoStyle: { width: '50px',height: '50px'},
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'distributorDetail']),
    ifUseTaskScheduling() {
      return this.$store.getters?.userInfo?.ifUseTaskScheduling
    },
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    ...mapActions(['setRePublishRowData', 'setDisplayRePublishRowData', 'setDistributorDetail']),
    getStatusText(status) {
      const statusMap = {
        '0': '失败',
        '1': '成功',
        '-1': '执行中',
        '-2': '排队中',
        '-3': '图片上传中',
        '2': '部分sku成功',
        '3': '图片审核中',
        '4': '已终止',
      }
      console.log(this.$fromGyl, '---$fromGyl--')
      return statusMap[String(status)] || ''
    },
    // 查询店铺授权是否失效
    async fetch_getWarning(shopId) {
      const res = await prodGetWarning();
      if(!res) return;
      const warns = res.warns || [];
      const item = warns.find(item => {
        return item.id == shopId 
      })
      if(item && item.invalidSession == 1) {
        return this.$message.error('重新铺货失败：店铺授权失效，请到“店铺管理“页面重新授权； ')
      }
    },
    // 打开商品中心编辑弹窗前，先删除已存在的dom
    removeProdCenterEditDialogDom() {
      const prodCenterEditDialog = document.querySelector('#prod-center-edit-dialog')
      if (prodCenterEditDialog) {
        prodCenterEditDialog.remove()
      }
    },
    async rePublish(rowData) {
      await this.fetch_getWarning(rowData.shopId);
      if (!rowData.baseItemId) {
        return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
      }
      // 铺货入口 0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货 5-店铺商品资料铺货 
      if(rowData.publishEntrance == 2) {
        const { records } = await prodDisplayGoodsList({
             companyId: rowData.extendVal2,
             distributeCompanyId: rowData.companyId,
             outerIds: rowData.outerId,
        });
        if(!(records && records.length)) return this.$message.error('重新铺货失败，该商品已被供销商设置成不可分销；');
        this.setDisplayRePublishRowData({rowData:{...records[0], 
          publishEntrance: rowData.publishEntrance, 
          publishType: rowData.publishType, 
          platform: rowData.platform,
          shopId: rowData.shopId,
          extendVal2: rowData.extendVal2,
          }
        });
        this.$router.push({
          name: `${this.routerPrefix}SupplierMineInfo`,
          query:{
            supplierId: rowData.extendVal2
          }
        })
      } else {
        if(rowData.publishType != 2){
          const res = await prodDetailByBaseItemIds({
            baseItemIds: [rowData.baseItemId]
          });
          if(!res) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
          this.removeProdCenterEditDialogDom()
          this.setRePublishRowData({rowData:{
            ...res[0], 
            publishEntrance: rowData.publishEntrance, 
            publishType: rowData.publishType, 
            platform: rowData.platform,
            shopId: rowData.shopId,
            errorMessage: rowData.errorMessage
            }
          });
          this.$router.push({
            name: `${this.routerPrefix}prod_center`
          })
        } else {
          // 如果是组合铺货
          const extendVal1 = JSON.parse(rowData.extendVal1);
          const res = await prodDetailByBaseItemIds({
            baseItemIds: extendVal1
          })
          if(!res) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
          if(res.length !== extendVal1.length) return this.$message.error('重新铺货失败：存在商品已经被删除，请重新维护商品资料；');
          this.removeProdCenterEditDialogDom()
          this.setRePublishRowData({rowData});
          this.$router.push({
            name: `${this.routerPrefix}prod_center`
          })
        }
      }
    },
    stopPublish(row) {
      this.$emit('stopPublishFn', row)
    },
    async imageCheckDetail(row) {
      const list = await getCheckImagesDetail({
        companyId: this.$store.getters.userInfo.companyId,
        shopId: row.shopId,
        operationLogId: row.operationLogId,
        baseItemId: row.baseItemId,
      });
      this.$refs.checkImagesDialogRef.method_open({ list })
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },

  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
::v-deep .el-table__body-wrapper .cell {
   min-height: 100px!important;
   height: auto!important;
   max-height: 210px;
}
.video-message {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  width: 56px;
}
</style>
